import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import VideoBg from "./components/VideoBg.vue";
import "./scss/index.scss";

require("./scss/base.scss");

Vue.component("video-bg", VideoBg);

Vue.config.productionTip = false;

window.global_event_bus = new Vue();

import {
  ProductAttributesModalPlugin,
  SelectMenuModalPlugin
} from "./plugins/uimodal.plugin.js";
Vue.use(ProductAttributesModalPlugin);
Vue.use(SelectMenuModalPlugin);

window.global_vue_instance = new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");
